// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeCreateForms-StyledBusinessForm_cls1__GMBM8","cls2":"PayeeCreateForms-StyledBusinessForm_cls2__pAuvu PayeeCreateForms-StyledBusinessForm_cls1__GMBM8"};